import { render, staticRenderFns } from "./QRService.vue?vue&type=template&id=087a2558&"
import script from "./QRService.vue?vue&type=script&lang=js&"
export * from "./QRService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports